<div class="modal-product">
  @if (productImage) {
    <figure class="modal-product__image">
      <img
        ngSrcset="100w, 200w"
        width="100"
        height="100"
        [ngSrc]="productImage"
        [alt]="productTitle"
        [loaderParams]="{ product: true, fallback: missingProductImageUrl }"
      />
    </figure>
  }
  <div class="modal-product__content">
    <div class="modal-product__data">
      <h6 class="modal-product__title">{{ productTitle }}</h6>
      <div class="modal-product__quantity"><span i18n="@@QUANTITY">Quantity: </span>{{ quantity }}</div>
    </div>

    <div class="modal-product__price">
      <app-product-price
        [feedId]="product?.v4ApiResponse.feedID"
        [productPriceInfo]="productPrice"
        [bundleRecommendedPricesProducts]="product"
      />
    </div>
  </div>
</div>
<div class="modal-buttons">
  <div class="modal-buttons__cart">
    <button type="button" class="btn btn-primary" (click)="proceedToCart()" i18n="@@GO_TO_CART">Proceed to cart</button>
  </div>
  <div class="modal-buttons__close">
    <button type="button" class="btn btn-link" (click)="closeModal()" i18n="@@CONTINUE_SHOPPING">Continue shopping</button>
  </div>
</div>
